var map = {
	"./back_office/hero_image.png": "./app/javascript/assets/images/solutions/back_office/hero_image.png",
	"./customer_service/hero_image.png": "./app/javascript/assets/images/solutions/customer_service/hero_image.png",
	"./effective_communication/hero_image.png": "./app/javascript/assets/images/solutions/effective_communication/hero_image.png",
	"./process_automation/hero_image.png": "./app/javascript/assets/images/solutions/process_automation/hero_image.png",
	"./smart_working/hero_image.png": "./app/javascript/assets/images/solutions/smart_working/hero_image.png",
	"./team_balance/hero_image.png": "./app/javascript/assets/images/solutions/team_balance/hero_image.png",
	"./timely_interventions/hero_image.png": "./app/javascript/assets/images/solutions/timely_interventions/hero_image.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./app/javascript/assets/images/solutions sync recursive \\.(png|jpe?g|svg)$";